import { render } from "./SearchIcon.vue?vue&type=template&id=4e320292"
const script = {}

import exportComponent from "C:\\Users\\Tony\\Documents\\SourceTree\\novatrans-spotlight\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__